export const what_awaits_ru = [
    {
        id: "xqLFLSHGbf",
        type: "header",
        data: {
            text: "Что тебя ждёт в MediaJasa?",
            level: 3,
        },
    },
    {
        id: "8Kv9LFnFXo",
        type: "paragraph",
        data: {
            text: "Присаживайся поудобнее, сейчас всё расскажем!",
        },
    },
    {
        id: "UqHUCvlE1w",
        type: "paragraph",
        data: {
            text: "Июнь — начнём наше путешествие: Определись с идеей и расскажи о ней через форму регистрации. А ещё на сайте можно узнать, как прошла программа в прошлых годах, пройти интересный тест, почитать карточки про создание контента и получить много новой полезной информации. Прием заявок пройдет в 2 этапа: на каждом мы отберем участников_ниц.",
        },
    },
    {
        id: "Bw9UYHpBDB",
        type: "paragraph",
        data: {
            text: "В июле — отправимся на Boostcamping. Это будет поход с тренингами, мастер-классами, поддержкой менторов_ок, йогой. В общем, будем всячески настраиваться на работу со своими проектами. На этом этапе мы будем шлифовать твою идею до идеала. После чего отберём финалистов MediaJasa, которые получат финансовую поддержку.",
        },
    },
    {
        id: "OSStjC_xxF",
        type: "paragraph",
        data: {
            text: "Сразу после Boostcamping и до конца ноября — реализация проектов. А мы и менторы_ки будем всячески оказывать поддержку: финансовую, материальную и ресурсную.&nbsp;",
        },
    },
];

export const what_awaits_kg = [
    {
        id: "PqWWvIKmz_",
        type: "header",
        data: {
            text: "MediaJasa менен сизди эмне күтүп турат?",
            level: 3,
        },
    },
    {
        id: "7EbuKr0XAr",
        type: "paragraph",
        data: {
            text: "Ыңгайлуу жайгашып отуруңуз, азыр баарын айтып беребиз.",
        },
    },
    {
        id: "8rRAls8SP2",
        type: "paragraph",
        data: {
            text: "Июнь — биздин саякаттын башталышы: идеяңызды аныктап, ал жөнүндө каттоо формасы аркылуу айтып бериңиз. Ошондой эле, сайтта мурунку долбоорлор жөнүндө маалымат окуу, кызыктуу тесттен өтүү, контент түзүү боюнча карточкаладрды окуу жана көптөгөн пайдалуу маалыматтарды алуу мүмкүн. Каттоо 2 этапта өтөт: ар биринин жыйынтыгында катышуучуларды тандайбыз.&nbsp;",
        },
    },
    {
        id: "cbIPMZbPci",
        type: "paragraph",
        data: {
            text: "Июлда Boostcamping'ге жөнөйбүз – жүрүштө тренингдер, мастер-класстар, менторлорду колдоосу жана йога сыяктуу иш-чаралар өтөт. Бул этапта идеяңызды идеалдуу деңгээлге жеткиребиз. Андан кийин каржылык колдоо ала турган MediaJasa'нын финалдык катышуучуларын тандайбыз.",
        },
    },
    {
        id: "AMUZ4yWbfe",
        type: "paragraph",
        data: {
            text: "Boostcamping бүтөрү менен жана ноябрь айынын аягына чейин сиз идеяңызды ишке ашырасыз. Биз ар тараптан колдоо көрсөтүүгө аракет кылабыз.",
        },
    },
];
